export default __webpack_public_path__ + "static/media/analytics-download-bg-dark.c047338d.png";